export interface AuthModel {
  api_token: string;
  refreshToken?: string;
  currentRole?: string;
  currentTerm?: string;
  currentYear?: string;
}

export interface UserAddressModel {
  addressLine: string;
  city: string;
  state: string;
  postCode: string;
}

export interface UserCommunicationModel {
  email: boolean;
  sms: boolean;
  phone: boolean;
}

export interface UserEmailSettingsModel {
  emailNotification?: boolean;
  sendCopyToPersonalEmail?: boolean;
  activityRelatesEmail?: {
    youHaveNewNotifications?: boolean;
    youAreSentADirectMessage?: boolean;
    someoneAddsYouAsAsAConnection?: boolean;
    uponNewOrder?: boolean;
    newMembershipApproval?: boolean;
    memberRegistration?: boolean;
  };
  updatesFromKeenthemes?: {
    newsAboutKeenthemesProductsAndFeatureUpdates?: boolean;
    tipsOnGettingMoreOutOfKeen?: boolean;
    thingsYouMissedSindeYouLastLoggedIntoKeen?: boolean;
    newsAboutStartOnPartnerProductsAndOtherServices?: boolean;
    tipsOnStartBusinessProducts?: boolean;
  };
}

export interface UserSocialNetworksModel {
  linkedIn: string;
  facebook: string;
  twitter: string;
  instagram: string;
}

export interface UserModel {
  id: number;
  username?: string;
  email?: string;
  first_Name?: string;
  last_Name?: string;
  fullName?: string;
  roles?: Array<string>;
  menus?: Array<string>;
  claims?: Array<string>;
  institutionId?: number;
  subinstitutionId?: number;
  subinstitutionTypeId?: number;
  customerId?: number;
  employeeId?: number;
  personId?: number;
  sellerId?: number;
  imageId?: number;
  unitId?: number;
}

export interface H5PUserModel {
  id: string;
  email: string;
  username: string;
  name: string;
  role: string;
  csrfToken: string;
}

export const initialH5PUser: H5PUserModel = {
  id: "",
  email: "",
  username: "",
  name: "",
  role: "",
  csrfToken: "",
};

export type BaseType = {
  createdBy?: number;
  createdOn?: Date;
  updatedBy?: number;
  updatedOn?: Date;
  status?: number;
};

export enum PublishingOptionModel {
  Observation = 1,
  Conversation = 2,
  Evaluation = 3,
}

export enum CurriculumTypeModel {
  Lesson = 1,
  Study = 2,
  Activity = 3,
}

export enum ProficiencyTestModel {
  Classic = 1,
  Likert = 2,
  AB_Type = 3,
  Manuel = 4,
  Factor5 = 5,
  Learning_Styles = 6,
}

export enum RoleModel {
  Admin = "Admin",
  InstitutionManager = "Institution Manager",
  SchoolManager = "School Manager",
  Teacher = "Teacher",
  Customer = "Customer",
  Person = "Person",
  Employee = "Employee",
  GuidanceManager = "Guidance Manager",
  GuidanceCoordinator = "Guidance Coordinator",
}

export enum RoleIdModel {
  Admin = 1,
  InstitutionManager = 2,
  SchoolManager = 4,
  Teacher = 5,
  Customer = 1003,
  Person = 1004,
  Employee = 1005,
  GuidanceManager = 1016,
}

enum Weekend {
  Friday = 1,
  Saturday = 2,
  Sunday = 3,
}

export enum ClaimModel {
  academicyear = "jk",
  academicyear_create = "uo",
  academicyear_delete = "8p",
  academicyear_update = "rh",
  academicyear_view = "2a",
  announcement = "2f",
  announcement_create = "06",
  announcement_delete = "vj",
  announcement_update = "5i",
  announcement_view = "xw",
  appointments = "x5",
  appointments_create = "x6",
  appointments_delete = "j1",
  appointments_update = "j3",
  appointments_view = "j8",
  city = "ro",
  city_create = "z7",
  city_delete = "kf",
  city_update = "2z",
  city_view = "68",
  class = "95",
  class_create = "sr",
  class_delete = "lb",
  class_update = "ru",
  class_view = "mb",
  country = "fl",
  country_create = "zv",
  country_delete = "wl",
  country_update = "ym",
  country_view = "4j",
  curriculum = "v8",
  curriculum_create = "1b",
  curriculum_delete = "7n",
  curriculum_update = "87",
  curriculum_view = "a8",
  curriculumselfassessment = "b8",
  curriculumselfassessment_create = "33",
  curriculumselfassessment_delete = "t8",
  curriculumselfassessment_update = "h1",
  curriculumselfassessment_view = "13",
  curriculumexam = "tr",
  curriculumexam_create = "3r",
  curriculumexam_delete = "wd",
  curriculumexam_update = "te",
  curriculumexam_view = "qw",
  curriculumexamyks = "we",
  curriculumexamyks_create = "wt",
  curriculumexamyks_delete = "wr",
  curriculumexamyks_update = "wu",
  curriculumexamyks_view = "wi",
  curriculumquestiontracking = "ww",
  curriculumquestiontracking_create = "kl",
  curriculumquestiontracking_delete = "ty",
  curriculumquestiontracking_update = "ds",
  curriculumquestiontracking_view = "qa",
  curriculumtodolist = "w5",
  curriculumtodolist_create = "qt",
  curriculumtodolist_delete = "qp",
  curriculumtodolist_update = "qf",
  curriculumtodolist_view = "qo",
  curriculumassignmenttracking = "py",
  curriculumassignmenttracking_create = "iy",
  curriculumassignmenttracking_delete = "iw",
  curriculumassignmenttracking_update = "ip",
  curriculumassignmenttracking_view = "is",
  curriculumsubject = "9j",
  curriculumsubject_create = "1x",
  curriculumsubject_delete = "rc",
  curriculumsubject_update = "eu",
  curriculumsubject_view = "82",
  customer = "sc",
  customerannouncement = "y0",
  customercurriculum = "jv",
  customerguidance = "be",
  customerinfo = "i5",
  customermessage = "ri",
  customerstudy = "t5",
  customersubinstitutionlesson = "qd",
  customersurvey = "sd",
  developmentacademy = "w1",
  developmentacademy_create = "w2",
  developmentacademy_delete = "w7",
  developmentacademy_update = "w8",
  developmentacademy_view = "w9",
  dashboard = "aa",
  dashboardannouncement = "50",
  dashboardcurriculum = "zt",
  dashboardcustomer = "jn",
  dashboardemployee = "xc",
  dashboardguidance = "5l",
  dashboardfile = "8l",
  dashboardstudy = "pv",
  dashboardsurvey = "b3",
  employee = "jt",
  employee_create = "jx",
  employee_delete = "mf",
  employee_update = "56",
  employee_view = "wq",
  employeelesson = "vp",
  employeelesson_create = "lt",
  employeelesson_delete = "4s",
  employeelesson_update = "y2",
  employeelesson_view = "rx",
  employeetype = "11",
  employeetype_create = "d1",
  employeetype_delete = "qq",
  employeetype_update = "kj",
  employeetype_view = "j9",
  gender = "po",
  gender_create = "xp",
  gender_delete = "vd",
  gender_update = "oe",
  gender_view = "7d",
  guidance = "h7",
  guidanceinfo = "h8",
  guidance_create = "gz",
  guidance_delete = "t2",
  guidance_update = "fr",
  guidance_decide = "gd",
  guidance_view = "3w",
  guidance_display_criteria = "3b",
  help = "9",
  help_create = "bj",
  help_delete = "r3",
  help_update = "ti",
  help_view = "rz",
  institution = "6q",
  institution_create = "df",
  institution_delete = "3x",
  institution_update = "qk",
  institution_view = "j0",
  language = "8c",
  language_create = "zs",
  language_delete = "h6",
  language_update = "0u",
  language_view = "fa",
  lesson = "6n",
  lesson_create = "2r",
  lesson_delete = "ne",
  lesson_update = "fi",
  lesson_view = "t9",
  message = "7i",
  message_create = "4y",
  message_delete = "vf",
  message_update = "mi",
  message_view = "1j",
  messagetype = "t7",
  messagetype_create = "lx",
  messagetype_delete = "xk",
  messagetype_update = "g5",
  messagetype_view = "9c",
  person = "md",
  person_create = "xn",
  person_delete = "x1",
  person_update = "me",
  person_view = "ab",
  persontype = "nk",
  persontype_create = "xa",
  persontype_delete = "cr",
  persontype_update = "1h",
  persontype_view = "je",
  place = "db",
  place_create = "fm",
  place_delete = "mw",
  place_update = "5",
  place_view = "7",
  reportannouncement = "lo",
  reportannouncement_create = "ce",
  reportannouncement_delete = "r8",
  reportannouncement_update = "lm",
  reportannouncement_view = "vr",
  reportcurriculum = "an",
  reportcurriculum_create = "lu",
  reportcurriculum_delete = "1q",
  reportcurriculum_update = "wp",
  reportcurriculum_view = "72",
  reportmessage = "zb",
  reportmessage_create = "c5",
  reportmessage_delete = "il",
  reportmessage_update = "fh",
  reportmessage_view = "de",
  reportstudy = "um",
  reportstudy_create = "5m",
  reportstudy_delete = "kn",
  reportstudy_update = "3e",
  reportstudy_view = "c6",
  reportsurvey = "t1",
  reportsurvey_create = "a3",
  reportsurvey_delete = "vu",
  reportsurvey_update = "hz",
  reportsurvey_view = "bt",
  role = "au",
  role_create = "f3",
  role_delete = "y6",
  role_update = "5h",
  role_view = "h3",
  roleclaim = "i1",
  roleclaim_create = "2u",
  roleclaim_delete = "nl",
  roleclaim_update = "ku",
  roleclaim_view = "d9",
  study = "dz",
  study_create = "pc",
  study_delete = "ka",
  study_update = "d6",
  study_view = "n1",
  studyeventtype = "9o",
  studyeventtype_create = "ug",
  studyeventtype_delete = "nq",
  studyeventtype_update = "12",
  studyeventtype_view = "1o",
  studytype = "h2",
  studytype_create = "nm",
  studytype_delete = "5j",
  studytype_update = "x2",
  studytype_view = "j7",
  subinstitution = "f9",
  subinstitution_create = "i4",
  subinstitution_delete = "uz",
  subinstitution_update = "nv",
  subinstitution_view = "o3",
  subinstitutionlesson = "jr",
  subinstitutionlesson_create = "6l",
  subinstitutionlesson_delete = "jh",
  subinstitutionlesson_update = "5t",
  subinstitutionlesson_view = "n0",
  subinstitutiontype = "ys",
  subinstitutiontype_create = "zp",
  subinstitutiontype_delete = "et",
  subinstitutiontype_update = "ay",
  subinstitutiontype_view = "kr",
  subinstitutiontypebranch = "ax",
  subinstitutiontypebranch_create = "rl",
  subinstitutiontypebranch_delete = "ie",
  subinstitutiontypebranch_update = "g1",
  subinstitutiontypebranch_view = "cp",
  subject = "44",
  subject_create = "nn",
  subject_delete = "ct",
  subject_update = "7q",
  subject_view = "sj",
  survey = "8m",
  survey_create = "q9",
  survey_delete = "ap",
  survey_update = "6b",
  survey_view = "8r",
  surveyquestion = "qb",
  surveyquestion_create = "m7",
  surveyquestion_delete = "7f",
  surveyquestion_update = "wf",
  surveyquestion_view = "hf",
  surveyresult = "ek",
  surveyresult_create = "ak",
  surveyresult_delete = "m4",
  surveyresult_update = "rt",
  surveyresult_view = "4q",
  surveytype = "tq",
  surveytype_create = "yo",
  surveytype_delete = "tw",
  surveytype_update = "4e",
  surveytype_view = "hy",
  term = "37",
  term_create = "yq",
  term_delete = "nx",
  term_update = "fx",
  term_view = "dm",
  test = "en",
  test_create = "5n",
  test_delete = "hj",
  test_update = "0v",
  test_view = "r7",
  ticket = "u8",
  ticket_create = "ua",
  ticket_delete = "hx",
  ticket_update = "nr",
  ticket_view = "47",
  ticketstatu = "zy",
  ticketstatu_create = "fp",
  ticketstatu_delete = "hm",
  ticketstatu_update = "w3",
  ticketstatu_view = "8t",
  tickettype = "v0",
  tickettype_create = "wy",
  tickettype_delete = "n8",
  tickettype_update = "ur",
  tickettype_view = "cl",
  unit = "x9",
  unit_create = "yx",
  unit_delete = "43",
  unit_update = "wk",
  unit_view = "d0",
  unittype = "iv",
  unittype_create = "it",
  unittype_delete = "rv",
  unittype_update = "iz",
  unittype_view = "kp",
  user = "jw",
  user_create = "y3",
  user_delete = "74",
  user_update = "16",
  user_view = "n3",
  userclaim = "lq",
  userclaim_create = "75",
  userclaim_delete = "6t",
  userclaim_update = "em",
  userclaim_view = "2g",
  userlogin = "6s",
  userlogin_create = "q2",
  userlogin_delete = "dj",
  userlogin_update = "2p",
  userlogin_view = "tb",
  userrole = "4f",
  userrole_create = "zq",
  userrole_delete = "vl",
  userrole_update = "yc",
  userrole_view = "xd",
  users = "67",
  users_create = "y1",
  users_delete = "ca",
  users_update = "ho",
  users_view = "pi",
  workingstatue = "sp",
  workingstatue_create = "3n",
  workingstatue_delete = "cf",
  workingstatue_update = "k6",
  workingstatue_view = "sz",
  customer_create = "6g",
  customer_delete = "mj",
  customer_update = "5k",
  customer_view = "of",
  chat = "lp",
  chat_create = "uu",
  chat_delete = "cg",
  chat_update = "dl",
  chat_view = "w6",
  subinstitutionsubinstitutiontype = "p5",
  subinstitutionsubinstitutiontype_create = "kk",
  subinstitutionsubinstitutiontype_delete = "yl",
  subinstitutionsubinstitutiontype_update = "3l",
  subinstitutionsubinstitutiontype_view = "4z",
  employeesubinstitutiontype = "xy",
  employeesubinstitutiontype_create = "xr",
  employeesubinstitutiontype_delete = "1y",
  employeesubinstitutiontype_update = "2y",
  employeesubinstitutiontype_view = "4a",
  currency = "jg",
  currency_create = "mo",
  currency_delete = "v3",
  currency_update = "qi",
  currency_view = "vq",
  pricing = "0r",
  pricing_create = "c3",
  pricing_delete = "nz",
  pricing_update = "28",
  pricing_view = "3g",
  offer = "1z",
  offer_create = "uq",
  offer_delete = "sv",
  offer_update = "r0",
  offer_view = "ws",
  offerstatus = "b0",
  offerstatus_create = "l3",
  offerstatus_delete = "3t",
  offerstatus_update = "6h",
  offerstatus_view = "za",
  offertype = "f0",
  offertype_create = "am",
  offertype_delete = "bw",
  offertype_update = "6e",
  offertype_view = "io",
  sale = "rk",
  sale_create = "a9",
  sale_delete = "h5",
  sale_update = "dy",
  sale_view = "7b",
  seller = "so",
  seller_create = "v2",
  seller_delete = "3y",
  seller_update = "u6",
  seller_view = "5u",
  customerexamresult = "6m",
  filetype = "ng",
  filetype_create = "4o",
  filetype_delete = "2w",
  filetype_update = "3q",
  filetype_view = "vh",
  fileshare = "wz",
  fileshare_create = "cm",
  fileshare_delete = "al",
  fileshare_update = "tm",
  fileshare_view = "i0",
  gallery = "rf",
  gallery_create = "6a",
  gallery_delete = "1f",
  gallery_update = "52",
  gallery_view = "di",
  file = "j2",
  file_create = "1m",
  file_delete = "p9",
  file_update = "cz",
  file_view = "hh",
  module = "83",
  module_create = "4g",
  module_delete = "f6",
  module_update = "ch",
  module_view = "wn",
  page = "lr",
  page_create = "9l",
  page_delete = "u7",
  page_update = "3j",
  page_view = "20",
  setting = "bo",
  setting_create = "b7",
  setting_delete = "6v",
  setting_update = "q5",
  setting_view = "sx",
  claimvalue = "fz",
  claimvalue_create = "2t",
  claimvalue_delete = "rs",
  claimvalue_update = "0j",
  claimvalue_view = "eh",
  moduleinstitution = "az",
  moduleinstitution_create = "8y",
  moduleinstitution_delete = "ll",
  moduleinstitution_update = "0p",
  moduleinstitution_view = "wb",
  logs = "nh",
  logs_create = "2c",
  logs_delete = "wx",
  logs_update = "oi",
  logs_view = "xl",
  customeracademicyear = "96",
  customeracademicyear_create = "9k",
  customeracademicyear_delete = "ha",
  customeracademicyear_update = "0b",
  customeracademicyear_view = "ny",
  personacademicyear = "i9",
  personacademicyear_create = "rn",
  personacademicyear_delete = "re",
  personacademicyear_update = "48",
  personacademicyear_view = "9y",
  prioritycoloringtype = "pt",
  prioritycoloringtype_create = "th",
  prioritycoloringtype_delete = "pd",
  prioritycoloringtype_update = "pu",
  prioritycoloringtype_view = "tg",
  shuttleacademicyear = "5w",
  shuttleacademicyear_create = "se",
  shuttleacademicyear_delete = "v4",
  shuttleacademicyear_update = "pd",
  shuttleacademicyear_view = "8g",
  course = "bb",
  course_create = "mm",
  course_delete = "jj",
  course_update = "ii",
  course_read = "pb",
  course_view = "i6",
  coursetype = "a1",
  coursetype_create = "a4",
  coursetype_delete = "a5",
  coursetype_update = "a6",
  coursetype_view = "a7",
  courselevel = "a0",
  courselevel_create = "b1",
  courselevel_delete = "b2",
  courselevel_update = "b4",
  courselevel_view = "b6",
  proficiencytest = "b9",
  proficiencytest_create = "c1",
  proficiencytest_delete = "c2",
  proficiencytest_update = "c4",
  proficiencytest_view = "c9",
  courseskillquestion = "z2",
  courseskillquestion_create = "z3",
  courseskillquestion_delete = "z4",
  courseskillquestion_update = "z5",
  courseskillquestion_view = "z8",
  courseskill = "t3",
  courseskill_create = "t4",
  courseskill_delete = "t6",
  courseskill_update = "p1",
  courseskill_view = "p2",
  courseresult = "o1",
  courseresult_create = "o4",
  courseresult_delete = "o7",
  courseresult_update = "o8",
  courseresult_view = "o9",
  courseresulttype = "p3",
  courseresulttype_create = "p4",
  courseresulttype_delete = "p6",
  courseresulttype_update = "p7",
  courseresulttype_view = "p8",
  courseskillfeedback = "x0",
  courseskillfeedback_create = "x3",
  courseskillfeedback_delete = "x4",
  courseskillfeedback_update = "x7",
  courseskillfeedback_view = "x8",
  courseresultcriteria = "y4",
  courseresultcriteria_create = "y7",
  courseresultcriteria_delete = "y8",
  courseresultcriteria_update = "v1",
  courseresultcriteria_view = "v6",
  courseschedule = "v7",
  courseschedule_create = "v9",
  courseschedule_delete = "q0",
  courseschedule_update = "q1",
  courseschedule_view = "q4",
  publishingoption = "q7",
  publishingoption_create = "q8",
  publishingoption_delete = "r1",
  publishingoption_update = "r2",
  publishingoption_view = "r4",

  courserole = "bp",
  courserole_create = "bs",
  courserole_delete = "bu",
  courserole_update = "bv",
  courserole_view = "by",

  guidancetype = "cv",
  guidancetype_create = "dd",
  guidancetype_delete = "dk",
  guidancetype_update = "dn",
  guidancetype_view = "do",

  guidancesubtype = "dp",
  guidancesubtype_create = "dr",
  guidancesubtype_delete = "dt",
  guidancesubtype_update = "dv",
  guidancesubtype_view = "ef",

  guidanceresulttype = "bz",
  guidanceresulttype_create = "cb",
  guidanceresulttype_delete = "cc",
  guidanceresulttype_update = "cd",
  guidanceresulttype_view = "cn",

  filearea = "bc",
  filearea_create = "bd",
  filearea_delete = "bf",
  filearea_update = "bk",
  filearea_view = "bn",

  guidancereport = "z0",
  guidancereport_create = "2n",
  guidancereport_delete = "ex",
  guidancereport_update = "fv",
  guidancereport_view = "b5",

  filereport = "yu",
  filereport_create = "yv",
  filereport_delete = "yw",
  filereport_update = "ya",
  filereport_view = "yb",

  fileview = "pg",
  fileview_create = "pz",
  fileview_delete = "pw",
  fileview_update = "pq",
  fileview_view = "pp",

  employeeunit = "vc",
  employeeunit_create = "vv",
  employeeunit_delete = "vs",
  employeeunit_update = "vt",
  employeeunit_view = "vu",

  curriculumtype = "ks",
  curriculumtype_create = "kt",
  curriculumtype_delete = "km",
  curriculumtype_update = "kb",
  curriculumtype_view = "kc",

  activity = "lm",
  activity_create = "lc",
  activity_delete = "ls",
  activity_update = "ln",
  activity_view = "ly",

  // zg-generateBlock(((zg-claim)))
}

export interface ErrorResponse {
  type: string;
  message: string;
  stackTrace: string;
}
